import { render, staticRenderFns } from "./addSonDict.vue?vue&type=template&id=a7f3f51c"
import script from "./addSonDict.vue?vue&type=script&lang=js"
export * from "./addSonDict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports